import { Guid } from "@/types"
import Notification, { IGetNotification } from "./Notification"

export interface IGetNotificationAdHocReservationCreatedDto extends IGetNotification {
    reservationId: Guid
    reservationNumber: string
}

export default class NotificationAdHocReservationCreated extends Notification {
    reservationId: Guid
    reservationNumber: string

    constructor(dto: IGetNotificationAdHocReservationCreatedDto) {
        super(dto)
        this.reservationId = dto.reservationId
        this.reservationNumber = dto.reservationNumber
    }
}
